import { useAppSelector } from "store/hooks";

const useColumnEdited = () => {
  const columnEdited = useAppSelector(
    (state) => state.developer.edit.editor.columnEdited
  );

  return columnEdited;
};

export default useColumnEdited;
